import { BASE_STYLES, Direction, Alignment, Justification, BASE_SPACING } from './constants.js';
import { generateShouldForwardPropsConfig } from '@doordash/utilities';
import '../themes/default/borderRadius/index.js';
import '../themes/default/borderWidth/index.js';
import '../themes/default/color/index.js';
import '../themes/default/shape/index.js';
import '../themes/default/size/index.js';
import { SpacingAll } from '../themes/default/spacing/index.js';
import '../theming/themes/caviar.js';
import '../theming/themes/merchant.js';
import '../theming/themes/merchant-next.js';
import '../theming/themes/internal-tools.js';
import '../theming/icons/constants.js';
import '../theming/logo/constants.js';
import '../theming/typography/constants.js';
import 'lodash.clonedeep';
import 'lodash.merge';
import React from 'react';
import styled, { css } from 'styled-components';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// This uses a modified "lobotomized owl selector".
// It selects all elements that are immediate children
// of the component `& > …`
// And then uses the universal selector `*` with the
// adjacent sibling selector `+` to select all immediate children
// that are preceded by a sibling.
//
// Resources:
// https://developer.mozilla.org/en-US/docs/Web/CSS/Adjacent_sibling_selectors
// https://alistapart.com/article/axiomatic-css-and-lobotomized-owls
var getLayoutStylingRules = function getLayoutStylingRules(_ref) {
  var shouldWrap = _ref.shouldWrap,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? BASE_SPACING : _ref$size,
      direction = _ref.direction;

  if (shouldWrap) {
    return css(["flex-wrap:wrap;& > *:not(:last-child){", "}"], direction === Direction.LTR ? "margin-right: ".concat(size, "px !important;") : "margin-left: ".concat(size, "px !important;"));
  }

  return css(["& > * + *{", "}"], direction === Direction.LTR ? "margin-left: ".concat(size, "px !important;") : "margin-right: ".concat(size, "px !important;"));
};

var nonDOMProps = ['shouldWrap', 'size', 'alignItems', 'justifyContent', 'direction'];
var StyledInlineChildren = styled.div.withConfig(generateShouldForwardPropsConfig(nonDOMProps)).withConfig({
  displayName: "InlineChildren__StyledInlineChildren",
  componentId: "sc-6r2tfo-0"
})(["", " display:flex;align-items:", ";justify-content:", ";flex-direction:", ";", ";"], BASE_STYLES, function (props) {
  return props.alignItems;
}, function (props) {
  return props.justifyContent;
}, function (props) {
  return props.direction === Direction.LTR ? 'row' : 'row-reverse';
}, getLayoutStylingRules);

var InlineChildren = function InlineChildren(_ref2) {
  var _ref2$alignItems = _ref2.alignItems,
      alignItems = _ref2$alignItems === void 0 ? Alignment.Stretch : _ref2$alignItems,
      _ref2$justifyContent = _ref2.justifyContent,
      justifyContent = _ref2$justifyContent === void 0 ? Justification.FlexStart : _ref2$justifyContent,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? BASE_SPACING : _ref2$size,
      _ref2$direction = _ref2.direction,
      direction = _ref2$direction === void 0 ? Direction.LTR : _ref2$direction,
      tag = _ref2.tag,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["alignItems", "justifyContent", "size", "direction", "tag", "children"]);

  return /*#__PURE__*/React.createElement(StyledInlineChildren, _extends({
    as: tag,
    alignItems: alignItems,
    justifyContent: justifyContent,
    size: size,
    direction: direction
  }, props), children);
};

InlineChildren.Sizes = SpacingAll;
InlineChildren.Justification = Justification;
InlineChildren.Alignment = Alignment;

export { InlineChildren as default };
